var React = require('react');

function SChevronrightmedium22N (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path","d":"m15.0926,11.14482c.00031-.26542-.10524-.52001-.29328-.70734l-4.98939-4.98939c-.38983-.39114-1.02293-.3922-1.41407-.00237s-.3922,1.02293-.00237,1.41407c.00079.00079.00158.00158.00237.00237l4.28267,4.28266-4.28267,4.28266c-.39121.38976-.39239,1.02286-.00264,1.41407.38976.39121,1.02286.39239,1.41407.00264.00088-.00088.00176-.00175.00264-.00264l4.98939-4.98939c.18804-.18732.2936-.44191.29328-.70734Z","fill":"var(--iconFill, #464646)"}));
}

SChevronrightmedium22N.defaultProps = {"id":"ImportedIcons","width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = SChevronrightmedium22N;

SChevronrightmedium22N.default = SChevronrightmedium22N;
